import { render, staticRenderFns } from "./BankDetailForm.vue?vue&type=template&id=416e8048"
import script from "./BankDetailForm.vue?vue&type=script&lang=js"
export * from "./BankDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports